export default "__VITE_ASSET__39INa_oD__"